// extracted by mini-css-extract-plugin
module.exports = {"stars":"_3bKG8HjdZt3aW5rRwkESuX","averageLabel":"qMjO5YpvIHrlf3QTZ4PdJ"};